import React from 'react';
import './theme.css';

/**
 * Shared Lendwise design-kit scope. Carries the brand tokens, shadcn HSL
 * overrides, and inherited typography under `.lw-ds`.
 *
 * Put `LW_DS_CLASS` DIRECTLY on a Radix *Content (Dialog/Sheet/Select/Dropdown/
 * Tooltip) — those portal internally, so an outer wrapper is NOT an ancestor of
 * the rendered content. For a screen root, add `lw-ds-page` (via `className`)
 * for the page background/layout.
 */
export const LW_DS_CLASS = 'lw-ds';

interface LwThemeScopeProps {
  children: React.ReactNode;
  className?: string;
}

export const LwThemeScope: React.FC<LwThemeScopeProps> = ({ children, className }) => (
  <div className={className ? `${LW_DS_CLASS} ${className}` : LW_DS_CLASS}>{children}</div>
);

export default LwThemeScope;
